export default __webpack_public_path__ + "static/media/52.223a7310.png";